var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "u:home-alt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3912 15.8018V7.86969C17.3912 7.35629 17.147 6.87467 16.7359 6.57637C15.4884 5.67195 11.9103 3.0763 10.475 2.03518C9.93084 1.64045 9.19936 1.64045 8.65519 2.03518C7.21988 3.0763 3.64179 5.67195 2.39432 6.57637C1.98319 6.87467 1.73901 7.35629 1.73901 7.86969V15.8018C1.73901 16.2236 1.90388 16.6278 2.19762 16.9256C2.49084 17.2239 2.88893 17.3913 3.30423 17.3913C5.99327 17.3913 13.1369 17.3913 15.826 17.3913C16.2413 17.3913 16.6394 17.2239 16.9326 16.9256C17.2263 16.6278 17.3912 16.2236 17.3912 15.8018ZM12.1738 16.3316H15.826C15.9642 16.3316 16.0973 16.276 16.1948 16.1764C16.2929 16.0773 16.3477 15.9422 16.3477 15.8018V7.86969C16.3477 7.69856 16.2663 7.53802 16.1291 7.43841L9.86823 2.89722C9.68719 2.76582 9.44301 2.76582 9.26197 2.89722L3.0011 7.43841C2.86388 7.53802 2.78249 7.69856 2.78249 7.86969V15.8018C2.78249 15.9422 2.83727 16.0773 2.93536 16.1764C3.03293 16.276 3.16597 16.3316 3.30423 16.3316H6.9564V11.5632C6.9564 10.6852 7.6571 9.97366 8.52162 9.97366H10.6086C11.4731 9.97366 12.1738 10.6852 12.1738 11.5632V16.3316ZM11.1303 16.3316H7.99988V11.5632C7.99988 11.2707 8.23362 11.0333 8.52162 11.0333H10.6086C10.8966 11.0333 11.1303 11.2707 11.1303 11.5632V16.3316Z",
    fill: "currentColor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.ae7c28ab2bedc4a165b1e3b0d8411e58.svg";
export { ForwardRef as ReactComponent };